<template>
  <v-container>
    <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <!--学術集会向けオンライン演題登録/査読システム-->
    <Content></Content>
  </v-container>
</template>

<script>
// 製品一覧コンポーネントをインポート
import Content from '../components/Registration/Content'

export default {
  name: 'Registrations',
  components: {
    Content
  }
}
</script>
<script>
import Content from '../components/Registration/Content'
export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
      {
        name: '製品情報',
        href: '/Products'
      },
     {
        name: '学術集会向けオンライン演題登録/査読システム',
        href: 'registration'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Content
  }
}
</script>
